import React, { useEffect, useLayoutEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthState } from '../../../../../../Helper/Context';


export default function IllegalConstructionSidebar(props) {

    const { active, listActive, reportsActive, ProjectTypeId, Language, YearValue, YearLabel, MonthValue, MonthLabel, WardValue, WardLabel, ZoneValue, ZoneLabel } = props
    const { t } = useTranslation()

  
    const userDetails = useAuthState();
    const { UserID, token, M_ProjectTypeID, RoleID } = userDetails
    const dispatch = useDispatch()


    const Pathname = window.location.pathname
    const [searchParams] = useSearchParams()
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")


    const [MasterProjectTypeID, setMasterProjectTypeID] = useState(ProjectTypeId)

    const navigate = useNavigate()


    const onMouseOver = () => {
        const sidebar = document.getElementById('SidebarToggle')
        const sidebaractive = sidebar.classList.contains("sidebaractive")
        if (!sidebaractive) {
            sidebar.classList.remove('active')
        }
    }

    const onMouseOut = () => {
        const sidebar = document.getElementById('SidebarToggle')
        const sidebaractive = sidebar.classList.contains("sidebaractive")
        if (!sidebaractive) {
            sidebar.classList.add('active')
        }
    }

    return (
   
        <nav className="pcoded-navbar sidebar mob_side active" id="SidebarToggle"
         
            onMouseOver={() => onMouseOver()}
            onMouseOut={() => onMouseOut()}
        >

            <div className="navbar-wrapper  " >
                <div className="navbar-content scroll-div ">
                    <ul className="nav pcoded-inner-navbar pt-5 pt-lg-2 mt-lg-4" >
                        <li className="nav-item pcoded-menu-caption dashIcon">
                            <div style={{ cursor: 'pointer' }}>

                                <div className={`${active === "garden" ? "active nav-item" : ""}`} style={{ cursor: 'pointer' }}
                                onClick={() => navigate(`/DakshaDashboard`)}
                                >
                                    <span className='d-flex align-items-center' >
                                        <img src={'assets/img/home.png'} style={{ width: "24px" }} />
                                        <span className='ml-2 poppins sidebarName' style={{ fontSize: '15px', color: '#eaedf0' }}> {t('Sidebar.Dashboard')}</span>
                                    </span>
                                </div>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>



    )
}

